/* eslint-disable */
import { useEffect } from 'react';
import { useFirstMountState } from './useFirstMountState';
var useUpdateEffect = function (effect, deps) {
    var isFirstMount = useFirstMountState();
    useEffect(function () {
        if (!isFirstMount) {
            return effect();
        }
    }, deps);
};
export default useUpdateEffect;



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/react-use/esm/useUpdateEffect.js
// module id = W0mE
// module chunks = 0